import React from 'react';

const { Fragment } = wp.element;
const { PanelBody, Dashicon, Button } = wp.components;

const { __ } = wp.i18n;

export default class AdvancedSettings extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			deletingLibrary: false,
		};
	}

	deleteLibrary = () => {
		this.setState( { deletingLibrary: true } );

		this.props.deleteLibrary();
	};

	render() {
		return (
			<Fragment>
				<PanelBody
					title={ __( 'Advanced Settings' ) }
					initialOpen={ false }
					className={ 'dsgn__advanced-settings' }
				>
					<Fragment>
						<div>
							<Button
								ref={ x => ( this._button_delete_library = x ) }
								className="design-upsell__cta dsgn__delete-library dsgn__delete-action"
								isBusy={ this.state.deletingLibrary }
								isLarge
								onClick={ () => {
									this._button_delete_library.blur(); // Loading animation isn't working without blur.
									this.deleteLibrary();
								} }
								disabled={ this.props.designsCount === 0 }
							>
								<Dashicon icon="trash" /> { __( 'Delete imported designs' ) }
							</Button>
						</div>
					</Fragment>
				</PanelBody>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/advanced-settings.jsx